import DashboardCard, { EmptyState } from './DashboardCard';
import CardGrid from './CardGrid';
import { CARD_FILL_MIN_WIDTH, cardDateColumn, type CardColumn } from './cardColumns';
import type { DashboardAllergyChange } from '../../types/dashboard';
import { useDashboardNav, RESIDENT_TAB } from './useDashboardNav';

const columns: CardColumn<DashboardAllergyChange>[] = [
  cardDateColumn<DashboardAllergyChange>('dateTimeOfLog', 'Date', { sortOrder: 'desc' }),
  { dataField: 'fullName', caption: 'Name', sizing: 'fill' },
  { dataField: 'allergyChanges', caption: 'Allergy', sizing: 'fill', minWidth: CARD_FILL_MIN_WIDTH },
];

interface Props {
  data: DashboardAllergyChange[];
  draggable?: boolean;
  onDragStart?: (e: React.DragEvent) => void;
  onDragOver?: (e: React.DragEvent) => void;
  onDrop?: (e: React.DragEvent) => void;
  onDragEnd?: () => void;
}

export default function AllergyChangesCard({ data, ...dragProps }: Props) {
  const { rowLinkProps } = useDashboardNav();
  return (
    <DashboardCard severity="alert" icon="bi-shield-exclamation" title="Allergy Changes" count={data.length} {...dragProps}>
      {data.length === 0 ? (
        <EmptyState message="No allergy changes" />
      ) : (
        <CardGrid<DashboardAllergyChange>
          {...rowLinkProps<DashboardAllergyChange>((r) => r.fKey_Patient, RESIDENT_TAB.allergies)}
          ariaLabel="Allergy Changes"
          dataSource={data}
          columns={columns}
          // One row per change: a resident can have several in the window.
          keyExpr={(r) => `${r.fKey_Patient}|${r.dateTimeOfLog}|${r.allergyChanges}`}
        />
      )}
    </DashboardCard>
  );
}
